import OwnerCoupons from "@/components/OwnerCoupons";

export default function OwnerCouponsPage() {
  return <OwnerCoupons />;
}
